import React from 'react'
import { DollarSign, Flame } from 'lucide-react'

function Programs() {
  return (
    <div id='Programs' className='md:mt-24 mt-12 md:p-12 p-4'>
        <div className='flex md:flex-row flex-col mx-auto justify-around gap-8 md:gap-4'>
            <div className='flex flex-col gap-4 md:w-1/3'>
                <h1 className='text-[#FFA300] md:text-5xl text-2xl font-handwriting'>What I offer</h1>
                <h1 className='md:text-5xl text-3xl font-bold text-[#16B97A] signika'>The Best Package Deals</h1>
                <h1 className='md:text-5xl text-xl alata font-bold'>For the best Price</h1>
                <p className='text-lg md:text-2xl font-semibold quicksand text-gray-600'>These are exclusive of transport</p>
                <p className='text-gray-600 quicksand flex items-start gap-2'>
                    <DollarSign className='text-[#16B97A] mt-1 flex-shrink-0'/>
                    <span>Cost depends on number of people and the type of food you want.</span>
                </p>
                 <p className='text-gray-600 quicksand flex items-start gap-2'>
                    <Flame className='text-[#16B97A] mt-1 flex-shrink-0'/>
                    <span>Cooking is on site (Or I can cook at my place and deliver to you).</span>
                </p>
            </div>
            
            <div className='flex mx-auto md:mx-0 my-8 md:my-0 flex-col items-center gap-4 shadow-[#16B97A] shadow-lg py-4 px-8 rounded-3xl md:w-[350px] w-full max-w-md'>
                <h1 className='text-3xl font-bold signika text-[#16B97A]'>Weekly Rate</h1>
                <small className='quicksand text-center'>Two meals a day Monday to Friday</small>
                <div className='bg-[#EDF7F8]/50 rounded-2xl flex flex-col gap-2 p-4 justify-center items-center w-full'>
                    <div className='flex gap-4 w-full justify-between'>
                        <h1 className='text-[#16B97A] font-bold'>1 pax</h1>
                        <h1 className='text-[#FFA300] font-bold'>ksh 9,200</h1>
                    </div>
                    <div className='flex gap-4 w-full justify-between'>
                        <h1 className='text-[#16B97A] font-bold'>2 pax</h1>
                        <h1 className='text-[#FFA300] font-bold'>ksh 13,600</h1>
                    </div>
                    <div className='flex gap-4 w-full justify-between'>
                        <h1 className='text-[#16B97A] font-bold'>3 pax</h1>
                        <h1 className='text-[#FFA300] font-bold'>ksh 16,300</h1>
                    </div>
                </div>
                <h1 className='text-2xl font-semibold alata text-[#FFA300]'>Labour Only</h1>
                <div className='bg-[#EDF7F8]/50 rounded-2xl flex flex-col gap-2 p-4 justify-center items-center w-full'>
                    <div className='flex gap-4 w-full justify-between'>
                        <h1 className='text-[#16B97A] font-bold'>1 pax</h1>
                        <h1 className='text-[#FFA300] font-bold'>ksh 3,500</h1>
                    </div>
                    <div className='flex gap-4 w-full justify-between'>
                        <h1 className='text-[#16B97A] font-bold'>2 pax</h1>
                        <h1 className='text-[#FFA300] font-bold'>ksh 4,800</h1>
                    </div>
                    <div className='flex gap-4 w-full justify-between'>
                        <h1 className='text-[#16B97A] font-bold'>3 pax</h1>
                        <h1 className='text-[#FFA300] font-bold'>ksh 5,800</h1>
                    </div>
                </div>
            </div>
            
            <div className='flex mx-auto md:mx-0 my-8 md:my-0 flex-col items-center gap-4 shadow-[#16B97A] shadow-lg py-4 px-8 rounded-3xl md:w-[350px] w-full max-w-md'>
                <h1 className='text-3xl font-bold signika text-[#16B97A]'>Monthly Rate</h1>
                <small className='quicksand text-center'>Two meals a day Monday to Friday</small>
                <div className='bg-[#EDF7F8]/50 rounded-2xl flex flex-col gap-2 p-4 justify-center items-center w-full'>
                    <div className='flex gap-4 w-full justify-between'>
                        <h1 className='text-[#16B97A] font-bold'>1 pax</h1>
                        <h1 className='text-[#FFA300] font-bold'>ksh 24,000</h1>
                    </div>
                    <div className='flex gap-4 w-full justify-between'>
                        <h1 className='text-[#16B97A] font-bold'>2 pax</h1>
                        <h1 className='text-[#FFA300] font-bold'>ksh 35,000</h1>
                    </div>
                    <div className='flex gap-4 w-full justify-between'>
                        <h1 className='text-[#16B97A] font-bold'>3 pax</h1>
                        <h1 className='text-[#FFA300] font-bold'>ksh 40,000</h1>
                    </div>
                </div>
                <h1 className='text-2xl font-semibold alata text-[#FFA300]'>Labour Only</h1>
                <div className='bg-[#EDF7F8]/50 rounded-2xl flex flex-col gap-2 p-4 justify-center items-center w-full'>
                    <div className='flex gap-4 w-full justify-between'>
                        <h1 className='text-[#16B97A] font-bold'>1 pax</h1>
                        <h1 className='text-[#FFA300] font-bold'>ksh 14,000</h1>
                    </div>
                    <div className='flex gap-4 w-full justify-between'>
                        <h1 className='text-[#16B97A] font-bold'>2 pax</h1>
                        <h1 className='text-[#FFA300] font-bold'>ksh 17,000</h1>
                    </div>
                    <div className='flex gap-4 w-full justify-between'>
                        <h1 className='text-[#16B97A] font-bold'>3 pax</h1>
                        <h1 className='text-[#FFA300] font-bold'>ksh 23,000</h1>
                    </div>
                </div>
            </div>
        </div>
    </div>
  )
}

export default Programs